import {dateToReadableDate} from '@date-picker';

import OrderDataRow from '../../../components/common/OrderDataRow/OrderDataRow';

type CustomerInfoProps = {
  customerName?: string;
  orderCode?: string;
  orderDate?: string;
  orderStatus?: string;
};

const CustomerInfo: React.FC<CustomerInfoProps> = ({
  customerName,
  orderCode,
  orderDate,
  orderStatus
}) => {
  return (
    <div className="flex flex-col">
      <OrderDataRow title="نام مشتری" value={customerName} />
      <OrderDataRow title="کد سفارش" value={orderCode} />
      <OrderDataRow
        title="زمان ثبت سفارش"
        value={dateToReadableDate({
          date: orderDate ?? '',
          day: true,
          month: true,
          year: true,
          hour: true,
          minute: true
        })}
      />
      <OrderDataRow title="وضعیت سفارش" value={orderStatus} />
    </div>
  );
};

export default CustomerInfo;
